import { forwardRef, useEffect, useRef } from "react";
import { AppTextarea, TAppTextareaProps } from "@libs/zapi-ui/custom";

export const InvisibleTextarea = forwardRef<HTMLTextAreaElement, TAppTextareaProps>((props, forwardedRef) => {
  const { className, ...otherProps } = props;
  const internalRef = useRef<HTMLTextAreaElement>(null);
  const textareaRef = (forwardedRef as React.RefObject<HTMLTextAreaElement>) || internalRef;

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const adjustHeight = () => {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    };

    adjustHeight();

    textarea.addEventListener("input", adjustHeight);
    return () => textarea.removeEventListener("input", adjustHeight);
  }, [textareaRef, props.value]);

  return (
    <AppTextarea
      ref={textareaRef}
      className={`border-0! ring-0! resize-none overflow-hidden hover:ring-0! focus-visible:ring-0! text-innoveraZinc-600 font-normal ${
        className || ""
      }`}
      {...otherProps}
    />
  );
});

InvisibleTextarea.displayName = "InvisibleTextarea";
